// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--_yI7y","header":"navigation-module--header--1LaQD","navigationItem":"navigation-module--navigationItem--1plNx"};